<div class="box">
  <form>
    <div class="h4 text-center mb-8px">เงินเดือนเท่านี้ เสียภาษีเท่าไหร่?</div>
    <div class="mb-8px">
      <app-sliding-tabs 
        [items]="options" 
        name="optionIncome" 
        [selected]="selectedOption" 
        (selectedChange)="onRadioChange($event)">
      </app-sliding-tabs>
    </div>
    <div class="mb-24px wrap-input">
      <app-income-input-number [(value)]="inputValue" (valueChange)="onValueChange($event)"></app-income-input-number>
    </div>
    <button type="button" class="btn btn-primary btn-block py-12px" (click)="calculate()">คำนวณภาษี</button>
  </form>
</div>